import {
  defaults as authDefaults,
  resolvers as authResolvers,
} from "./resolvers"

export const defaults = {
  ...authDefaults,
}

export const resolvers = {
  ...authResolvers,
}
